<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-4" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        {{drawerTitle}}
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="mb-3">
                        <label class="control-label">Project Name</label>
                        <input
                                name="title"
                                v-model="project.title"
                                type="text"
                                class="form-control"
                                data-vv-validate-on="input|blur"
                                data-vv-as="title"
                                v-validate="'required'"
                        />
                        <help-block field="title"/>
                    </div>

                    <div class="mb-3">
                        <label class="control-label">Select Client</label>
                        <div class="input-group">
                            <span class="input-group-text"><i class="fal fa-fw fa-building"></i></span>
                            <div class="flex-grow-1">
                                <multiselect :show-labels="false" v-model="client" :options="clients" label="display_name" track-by="id" placeholder="" v-validate="'required'" data-vv-name="client" @select="clientSelected"></multiselect>
                            </div>
                        </div>
                        <help-block field="client"/>
                    </div>

                    <div class="mb-3">
                        <label class="control-label">Owner</label>
                        <div class="input-group">
                            <span class="input-group-text"><i class="fal fa-fw fa-user"></i></span>
                            <div class="flex-grow-1">
                                <multiselect :show-labels="false" v-model="user" :options="users" label="name" track-by="id" placeholder="Select Owner" v-validate="'required'" data-vv-name="user" @select="ownerSelected"></multiselect>
                            </div>
                        </div>
                        <help-block field="user"/>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-bs-dismiss="modal">Cancel</button>
                        <c-button @click="handleSave" class="btn btn-rounded btn-primary">Save</c-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .form-control {
        box-shadow: none !important;
    }

    .form-control[readonly] {
        background-color: transparent !important;
    }
</style>

<script>

    import moment from 'moment'
    import { http } from 'utils'
    import { notify } from 'utils'
    import Multiselect from 'vue-multiselect'
    import { unset, cloneDeep } from 'lodash'
    import Datepicker from 'vuejs-datepicker'
    import Project from './../../models/project.js'
    import { mapActions, mapState, mapGetters } from 'vuex'
    import { Selectize, LaddaButton } from 'components/form/input'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        $_veeValidate: {
            validator: 'new' // give me my own validator scope.
        },
        props: ['propProject'],
        extends: CModal,
        components: {
            Selectize,
            LaddaButton,
            Datepicker,
            Multiselect
        },

        data() {
            return {
                project: {},
                types: ['Stage 1', 'Stage 2', 'Stage 3', 'Stage 1 & 2', 'Variation', 'Full Budget', 'T&M', 'Consult', 'Template'],
                client: null,
                contact: null,
                user: null
            }
        },

         mounted() {

            this.getClients()
            this.getUsers()

            this.addEventListener('open', () => {
                this.project = cloneDeep(this.propProject)

                if (this.project.client_id) {
                    this.client = this.getClientById(this.project.client_id)

                    this.user = this.getUserById(this.project.project_owner_id)
                }
            });
        },

        computed: {
            ...mapState('contacts', ['contacts']),
            ...mapState('contacts', ['client_id']),
            ...mapState('clientsList', ['clients']),
            ...mapState('users', ['users']),
            ...mapGetters('clientsList', {getClientById: 'getById'}),
            ...mapGetters('contacts', {getContactById: 'getById'}),
            ...mapGetters('users', {getUserById: 'getById'}),

            drawerTitle () {
              if (this.project.id) {
                return 'Edit Project'
              }

              return 'Create Project'
            }
        },

        methods: {
            ...mapActions('yodizproject', ['addSingle', 'updateSingle']),
            ...mapActions('clientsList', ['getClients']),
            ...mapActions('users', ['getUsers']),
            ...mapActions('contacts', ['getContacts']),

            clientSelected(selected) {
                this.project.client_id = selected.id
            },

            ownerSelected(selected) {
                this.project.project_owner_id = selected.id
            },

            contactSelected(selected) {
                this.newOpportunity.contact_id = selected.id
            },

            typeSelected(selected) {
                this.newOpportunity.lead_type = selected.id
            },

            handleSave() {
                if (this.project.id) {
                    return this.handleUpdateProject();
                } else {
                    return this.handleCreateProject();
                }
            },

            async handleCreateProject() {

                if (!await this._validate()) {
                    notify.error('Form validation failed, please check your inputs and try again.')
                    return Promise.reject()
                }

                let response = await this.addSingle(this.project);

                // Wait for the hide transition to finish so the backdrop is removed before navigating away
                await new Promise((resolve) => {
                    this.$el.addEventListener('hidden.bs.modal', resolve, { once: true })
                    this.close()
                })

                this.$router.push({ name: 'projects.show.details', params: { project_id: response.data.data.id } })
            },

            async handleUpdateProject() {

                if (!await this._validate()) {
                    notify.error('Form validation failed, please check your inputs and try again.')
                    return Promise.reject()
                }

                let response = await this.updateSingle({id:this.project.id, payload:this.project});

                notify.success('Project successfuly updated.')

                this.close()
            },
        }
    }
</script>
